module.exports = __webpack_public_path__ + "img/ELONG.7e6d6d59.png";